/* ==========================================================
   Mchose PDP — Variant switch + AJAX cart + Lightbox + Loadmore + Compre Junto
   ========================================================== */
(function () {
  'use strict';

  function initPdp() {
    var form = document.querySelector('[data-mc-form]');
    if (!form) return;

    var variantInput = form.querySelector('[data-mc-variant-input]');
    var variantCards = document.querySelectorAll('[data-mc-variant-id]');
    var currentColor = document.querySelector('[data-mc-current-color]');
    var ctaButton    = document.querySelector('[data-mc-add-button]');
    var ctaLabel     = document.querySelector('[data-mc-cta-label]');
    var installmentValue = document.querySelector('[data-mc-installment-value]');
    var priceToEl    = document.querySelector('[data-mc-price-to]');
    var priceFromEl  = document.querySelector('.mc-pdp__price-from');
    var pixValueEl   = document.querySelector('[data-mc-pix-value]');
    var pixTagEl     = document.querySelector('[data-mc-pix-tag]');
    var skuEl        = document.querySelector('[data-mc-sku]');

    // Lê % desconto Pix do DOM
    var pixDiscount = 10;
    if (pixTagEl) {
      var match = pixTagEl.textContent.match(/(\d+)/);
      if (match) pixDiscount = parseInt(match[1], 10);
    }

    function formatMoney(cents) {
      var value = cents / 100;
      return 'R$ ' + value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    /* ============== Cleanup do scroll quando o drawer fecha ============== */
    function cleanupBodyScroll() {
      document.documentElement.classList.remove('cart-drawer-open', 'has-drawer-open');
      document.body.classList.remove('overflow-hidden', 'js-drawer-open', 'cart-open');
      if (document.body.style.overflow === 'hidden') {
        document.body.style.overflow = '';
      }
    }

    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target) return;
      var closeBtn = target.closest && target.closest(
        'cart-drawer [aria-label*="echar" i], ' +
        'cart-drawer [aria-label*="lose" i], ' +
        'cart-drawer .drawer__close, ' +
        'cart-drawer button[type="button"][class*="close"], ' +
        '#CartDrawer-Overlay, ' +
        '.cart-drawer__overlay'
      );
      if (closeBtn) setTimeout(cleanupBodyScroll, 300);
    });

    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') setTimeout(cleanupBodyScroll, 300);
    });

    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl && window.MutationObserver) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'open' || m.attributeName === 'class') {
            var isOpen = cartDrawerEl.hasAttribute('open') ||
                         cartDrawerEl.classList.contains('active') ||
                         cartDrawerEl.classList.contains('is-open');
            if (!isOpen) cleanupBodyScroll();
          }
        });
      }).observe(cartDrawerEl, { attributes: true });
    }

    /* ============== Troca de variante ============== */
    variantCards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (card.classList.contains('is-disabled')) return;

        var variantId = card.dataset.mcVariantId;
        var variantName = card.dataset.mcVariantName;

        variantCards.forEach(function (c) { c.classList.remove('is-active'); });
        card.classList.add('is-active');

        if (currentColor) currentColor.textContent = variantName;
        if (variantInput) variantInput.value = variantId;

        fetchVariant(variantId);
      });
    });

    function fetchVariant(variantId) {
      var handle = window.location.pathname.split('/products/')[1];
      if (!handle) return;
      handle = handle.split('/')[0].split('?')[0];

      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var variant = product.variants.find(function (v) { return v.id == variantId; });
          if (!variant) return;

          if (priceToEl) priceToEl.textContent = formatMoney(variant.price);

          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            if (priceFromEl) {
              priceFromEl.textContent = 'de ' + formatMoney(variant.compare_at_price);
              priceFromEl.style.display = '';
            }
          } else if (priceFromEl) {
            priceFromEl.style.display = 'none';
          }

          if (installmentValue) installmentValue.textContent = formatMoney(variant.price / 10);

          if (pixValueEl) {
            var pixPrice = variant.price * (100 - pixDiscount) / 100;
            pixValueEl.textContent = formatMoney(pixPrice);
          }

          if (skuEl && variant.sku) skuEl.textContent = variant.sku;

          if (ctaButton && ctaLabel) {
            if (variant.available) {
              ctaButton.disabled = false;
              ctaLabel.textContent = 'Adicionar ao carrinho';
            } else {
              ctaButton.disabled = true;
              ctaLabel.textContent = 'Esgotado';
            }
          }

          var newUrl = new URL(window.location.href);
          newUrl.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', newUrl.toString());
        })
        .catch(function (err) { console.error('[mchose-pdp]', err); });
    }

    /* ============== Add to cart manual + abre cart-drawer ============== */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (ctaButton.disabled) return;

      var originalLabel = ctaLabel ? ctaLabel.textContent : '';
      if (ctaLabel) ctaLabel.textContent = 'Adicionando...';
      ctaButton.disabled = true;

      var formData = new FormData(form);
      var sectionsToFetch = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text'];
      formData.append('sections', sectionsToFetch.join(','));
      formData.append('sections_url', window.location.pathname);

      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            if (ctaLabel) ctaLabel.textContent = response.message || 'Indisponível';
            setTimeout(function () {
              if (ctaLabel) ctaLabel.textContent = originalLabel;
              ctaButton.disabled = false;
            }, 2200);
            return;
          }

          console.log('[mchose] response:', response);

          var cartDrawer = document.querySelector('cart-drawer')
            || document.getElementById('Cart-Drawer')
            || document.getElementById('CartDrawer')
            || document.querySelector('[id*="cart-drawer"]')
            || document.querySelector('cart-notification');

          console.log('[mchose] cartDrawer encontrado:', cartDrawer);

          if (response.sections && response.sections['cart-drawer']) {
            var parser = new DOMParser();
            var newDoc = parser.parseFromString(response.sections['cart-drawer'], 'text/html');
            var newDrawerContent = newDoc.querySelector('cart-drawer')
              || newDoc.querySelector('#Cart-Drawer')
              || newDoc.querySelector('[id*="cart-drawer"]')
              || newDoc.body.firstElementChild;

            if (cartDrawer && newDrawerContent) {
              cartDrawer.innerHTML = newDrawerContent.innerHTML;
              cartDrawer.classList.remove('is-empty');
              console.log('[mchose] Drawer HTML atualizado');
            }
          }

          if (response.sections && response.sections['cart-icon-bubble']) {
            var bubbleParser = new DOMParser();
            var bubbleDoc = bubbleParser.parseFromString(response.sections['cart-icon-bubble'], 'text/html');

            var currentBubble = document.getElementById('Cart-Icon-Bubble');
            var newBubble = bubbleDoc.getElementById('Cart-Icon-Bubble');

            if (currentBubble && newBubble) {
              currentBubble.innerHTML = newBubble.innerHTML;
              console.log('[mchose] badge Cart-Icon-Bubble atualizado');
            } else {
              var currentCount = document.querySelector('.header-cart-bubble .cart-count-bubble, .header-cart-bubble [class*="cart-count"]');
              var newCount = bubbleDoc.querySelector('.cart-count-bubble, [class*="cart-count"]');
              if (currentCount && newCount) {
                currentCount.outerHTML = newCount.outerHTML;
              }
            }

            var currentOpener = document.querySelector('modal-opener.header-cart-bubble');
            var newOpener = bubbleDoc.querySelector('modal-opener.header-cart-bubble');
            if (currentOpener && newOpener && newOpener.getAttribute('aria-label')) {
              currentOpener.setAttribute('aria-label', newOpener.getAttribute('aria-label'));
            }
          }

          var opened = false;

          if (cartDrawer && typeof cartDrawer.open === 'function') {
            try {
              cartDrawer.open();
              opened = true;
              console.log('[mchose] abriu via .open()');
            } catch (err) {}
          }

          if (!opened) {
            ['cart:open', 'cart-drawer:open', 'cart:updated', 'cart:refresh'].forEach(function (eName) {
              document.dispatchEvent(new CustomEvent(eName, { bubbles: true, detail: { cart: response } }));
            });
          }

          if (cartDrawer) {
            cartDrawer.removeAttribute('hidden');
            cartDrawer.removeAttribute('inert');
            cartDrawer.setAttribute('open', '');
            cartDrawer.classList.add('active', 'is-open', 'open', 'is-visible', 'is-active', 'animate');
          }

          if (!opened) {
            setTimeout(function () {
              var stillClosed = cartDrawer && !cartDrawer.classList.contains('active') && cartDrawer.offsetParent === null;
              if (stillClosed) {
                var iconBubble = document.getElementById('cart-icon-bubble')
                  || document.getElementById('Cart-Icon-Bubble')
                  || document.querySelector('[href="/cart"]')
                  || document.querySelector('[data-cart-toggle]');
                if (iconBubble && iconBubble.click) iconBubble.click();
              }
            }, 100);
          }

          if (ctaLabel) ctaLabel.textContent = '✓ Adicionado!';
          setTimeout(function () {
            if (ctaLabel) ctaLabel.textContent = originalLabel;
            ctaButton.disabled = false;
          }, 1500);
        })
        .catch(function (err) {
          console.error('[mchose-pdp] erro add:', err);
          if (ctaLabel) ctaLabel.textContent = originalLabel;
          ctaButton.disabled = false;
        });
    });

    /* ============== Smooth scroll do "Ler mais" ============== */
    var readmoreBtn = document.querySelector('[data-mc-readmore]');
    if (readmoreBtn) {
      readmoreBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById('mc-tabs');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    /* ============== "Ver mais imagens" / "Ver menos" (toggle) ============== */
    var loadmoreBtn   = document.querySelector('[data-mc-loadmore]');
    var loadmoreLabel = document.querySelector('[data-mc-loadmore-label]');
    var loadmoreIcon  = document.querySelector('[data-mc-loadmore-icon]');

    if (loadmoreBtn && loadmoreLabel) {
      document.querySelectorAll('.mc-pdp__gallery-item.is-hidden').forEach(function (el) {
        el.setAttribute('data-mc-hidden-initial', 'true');
      });

      loadmoreBtn.addEventListener('click', function () {
        var isCollapsed = loadmoreBtn.dataset.mcState === 'collapsed';
        var hiddenItems = document.querySelectorAll('[data-mc-hidden-initial="true"]');

        if (isCollapsed) {
          hiddenItems.forEach(function (el) { el.classList.remove('is-hidden'); });
          loadmoreBtn.dataset.mcState = 'expanded';
          loadmoreLabel.textContent = 'Ver menos';
          if (loadmoreIcon) loadmoreIcon.style.transform = 'rotate(180deg)';
        } else {
          hiddenItems.forEach(function (el) { el.classList.add('is-hidden'); });
          loadmoreBtn.dataset.mcState = 'collapsed';
          loadmoreLabel.textContent = 'Ver mais imagens';
          if (loadmoreIcon) loadmoreIcon.style.transform = 'rotate(0deg)';

          var gallery = document.querySelector('[data-mc-gallery]');
          if (gallery) gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    /* ============== Bullets do carrossel mobile ============== */
    initGalleryBullets();

    function initGalleryBullets() {
      var gallery = document.querySelector('[data-mc-gallery]');
      var bullets = document.querySelectorAll('[data-mc-bullet]');
      var items   = document.querySelectorAll('.mc-pdp__gallery-item');
      var bulletsContainer = document.querySelector('.mc-pdp__gallery-bullets');
      var counterEl = document.querySelector('[data-mc-gallery-counter]');

      if (!gallery || !bullets.length) return;

      var totalItems = items.length;

      // Atualiza o contador "X / Y"
      function updateCounter(idx) {
        if (counterEl) {
          counterEl.textContent = (idx + 1) + ' / ' + totalItems;
        }
      }

      // Centraliza o bullet ativo dentro do container (scroll infinito visual)
      function scrollBulletIntoCenter(activeBullet) {
        if (!bulletsContainer || !activeBullet) return;

        var containerWidth = bulletsContainer.clientWidth;
        var bulletLeft = activeBullet.offsetLeft;
        var bulletWidth = activeBullet.offsetWidth;

        // Target = posição que coloca o bullet ativo no CENTRO do container visível
        var targetScroll = bulletLeft - (containerWidth / 2) + (bulletWidth / 2);

        // Não permite scroll negativo (primeiro bullet fica colado à esquerda)
        if (targetScroll < 0) targetScroll = 0;

        // Não permite passar do limite máximo
        var maxScroll = bulletsContainer.scrollWidth - containerWidth;
        if (targetScroll > maxScroll) targetScroll = maxScroll;

        bulletsContainer.scrollTo({
          left: targetScroll,
          behavior: 'smooth'
        });
      }

      bullets.forEach(function (bullet) {
        bullet.addEventListener('click', function () {
          var idx = parseInt(bullet.dataset.mcBullet, 10);
          var target = items[idx];
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
      });

      if (!('IntersectionObserver' in window)) {
        updateCounter(0);
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            var idx = Array.prototype.indexOf.call(items, entry.target);
            if (idx < 0) return;
            bullets.forEach(function (b) { b.classList.remove('is-active'); });
            var activeBullet = document.querySelector('[data-mc-bullet="' + idx + '"]');
            if (activeBullet) {
              activeBullet.classList.add('is-active');
              scrollBulletIntoCenter(activeBullet);
            }
            updateCounter(idx);
          }
        });
      }, { root: gallery, threshold: [0.5] });

      items.forEach(function (item) { observer.observe(item); });

      // Inicializa contador no primeiro bullet
      updateCounter(0);
    }

    /* ============== Compre Junto ============== */
    initCompreJunto();

    function initCompreJunto() {
      var trigger = document.querySelector('[data-mc-cj-open]');
      var modal   = document.querySelector('[data-mc-cj-modal]');
      if (!trigger || !modal) return;

      var closeBtns = modal.querySelectorAll('[data-mc-cj-close]');
      var checkboxes = modal.querySelectorAll('[data-mc-cj-checkbox]');
      var totalEl = modal.querySelector('[data-mc-cj-total]');
      var addBtn = modal.querySelector('[data-mc-cj-add]');
      var cjCtaLabel = modal.querySelector('[data-mc-cj-cta-label]');

      var dataScript = document.querySelector('[data-mc-cj-data]');
      var cjData = {};
      if (dataScript) {
        try { cjData = JSON.parse(dataScript.textContent); }
        catch (e) { console.warn('[mc-cj] dados inválidos:', e); }
      }

      function formatMoneyCj(cents) {
        var value = cents / 100;
        return 'R$ ' + value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }

      function calculateTotal() {
        var total = cjData.currentPrice || 0;
        var count = 1;

        checkboxes.forEach(function (cb) {
          if (cb.checked && !cb.disabled) {
            var idx = cb.dataset.mcCjCheckbox;
            if (idx === '1' && cjData.addon1Price) total += cjData.addon1Price;
            if (idx === '2' && cjData.addon2Price) total += cjData.addon2Price;
            count++;
          }
        });

        if (totalEl) totalEl.textContent = formatMoneyCj(total);

        var installmentEl = modal.querySelector('[data-mc-cj-installment]');
        if (installmentEl) {
          var parcela = total / 10;
          installmentEl.innerHTML = 'em até <strong>10x de ' + formatMoneyCj(parcela) + '</strong> sem juros';
        }

        var cjPixValueEl = modal.querySelector('[data-mc-cj-pix-value]');
        if (cjPixValueEl) {
          var pixTotal = total * 0.9;
          cjPixValueEl.textContent = formatMoneyCj(pixTotal);
        }

        if (cjCtaLabel) {
          if (count === 1) cjCtaLabel.textContent = 'Adicionar somente atual';
          else if (count === 2) cjCtaLabel.textContent = 'Adicionar combo (2 itens)';
          else cjCtaLabel.textContent = 'Adicionar combo (' + count + ' itens)';
        }
      }

      function openModal() {
        if (modal.parentElement !== document.body) {
          document.body.appendChild(modal);
        }
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        calculateTotal();
      }

      function closeModal() {
        modal.hidden = true;
        document.body.style.overflow = '';
      }

      trigger.addEventListener('click', openModal);

      closeBtns.forEach(function (btn) {
        btn.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });

      checkboxes.forEach(function (cb) {
        cb.addEventListener('change', calculateTotal);
      });

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var items = [{ id: cjData.currentVariantId, quantity: 1 }];

          checkboxes.forEach(function (cb) {
            if (cb.checked && !cb.disabled) {
              var idx = cb.dataset.mcCjCheckbox;
              if (idx === '1' && cjData.addon1VariantId) {
                items.push({ id: cjData.addon1VariantId, quantity: 1 });
              }
              if (idx === '2' && cjData.addon2VariantId) {
                items.push({ id: cjData.addon2VariantId, quantity: 1 });
              }
            }
          });

          var originalLabel = cjCtaLabel ? cjCtaLabel.textContent : '';
          if (cjCtaLabel) cjCtaLabel.textContent = 'Adicionando...';
          addBtn.disabled = true;

          var sectionsToFetch = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text'];

          fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            },
            body: JSON.stringify({
              items: items,
              sections: sectionsToFetch.join(','),
              sections_url: window.location.pathname
            })
          })
            .then(function (r) { return r.json(); })
            .then(function (response) {
              if (response.status) {
                if (cjCtaLabel) cjCtaLabel.textContent = response.message || 'Indisponível';
                setTimeout(function () {
                  if (cjCtaLabel) cjCtaLabel.textContent = originalLabel;
                  addBtn.disabled = false;
                }, 2200);
                return;
              }

              console.log('[mc-cj] response:', response);

              var cartDrawer = document.querySelector('cart-drawer')
                || document.getElementById('Cart-Drawer')
                || document.getElementById('CartDrawer')
                || document.querySelector('[id*="cart-drawer"]')
                || document.querySelector('cart-notification');

              if (response.sections && response.sections['cart-drawer']) {
                var parser = new DOMParser();
                var newDoc = parser.parseFromString(response.sections['cart-drawer'], 'text/html');
                var newDrawerContent = newDoc.querySelector('cart-drawer')
                  || newDoc.querySelector('#Cart-Drawer')
                  || newDoc.querySelector('[id*="cart-drawer"]')
                  || newDoc.body.firstElementChild;

                if (cartDrawer && newDrawerContent) {
                  cartDrawer.innerHTML = newDrawerContent.innerHTML;
                  cartDrawer.classList.remove('is-empty');
                }
              }

              if (response.sections && response.sections['cart-icon-bubble']) {
                var bubbleParser = new DOMParser();
                var bubbleDoc = bubbleParser.parseFromString(response.sections['cart-icon-bubble'], 'text/html');

                var currentBubble = document.getElementById('Cart-Icon-Bubble');
                var newBubble = bubbleDoc.getElementById('Cart-Icon-Bubble');

                if (currentBubble && newBubble) {
                  currentBubble.innerHTML = newBubble.innerHTML;
                } else {
                  var currentCount = document.querySelector('.header-cart-bubble .cart-count-bubble, .header-cart-bubble [class*="cart-count"]');
                  var newCount = bubbleDoc.querySelector('.cart-count-bubble, [class*="cart-count"]');
                  if (currentCount && newCount) currentCount.outerHTML = newCount.outerHTML;
                }

                var currentOpener = document.querySelector('modal-opener.header-cart-bubble');
                var newOpener = bubbleDoc.querySelector('modal-opener.header-cart-bubble');
                if (currentOpener && newOpener && newOpener.getAttribute('aria-label')) {
                  currentOpener.setAttribute('aria-label', newOpener.getAttribute('aria-label'));
                }
              }

              if (cjCtaLabel) cjCtaLabel.textContent = '✓ Adicionado!';

              setTimeout(function () {
                closeModal();

                var opened = false;

                if (cartDrawer && typeof cartDrawer.open === 'function') {
                  try {
                    cartDrawer.open();
                    opened = true;
                  } catch (err) {
                    console.warn('[mc-cj] .open() falhou:', err);
                  }
                }

                if (!opened) {
                  ['cart:open', 'cart-drawer:open', 'cart:updated', 'cart:refresh'].forEach(function (eName) {
                    document.dispatchEvent(new CustomEvent(eName, { bubbles: true, detail: { cart: response } }));
                  });
                }

                if (cartDrawer) {
                  cartDrawer.removeAttribute('hidden');
                  cartDrawer.removeAttribute('inert');
                  cartDrawer.setAttribute('open', '');
                  cartDrawer.classList.add('active', 'is-open', 'open', 'is-visible', 'is-active', 'animate');
                }

                if (!opened) {
                  setTimeout(function () {
                    var stillClosed = cartDrawer && !cartDrawer.classList.contains('active') && cartDrawer.offsetParent === null;
                    if (stillClosed) {
                      var iconBubble = document.getElementById('cart-icon-bubble')
                        || document.getElementById('Cart-Icon-Bubble')
                        || document.querySelector('[href="/cart"]')
                        || document.querySelector('[data-cart-toggle]');
                      if (iconBubble && iconBubble.click) iconBubble.click();
                    }
                  }, 100);
                }

                if (cjCtaLabel) cjCtaLabel.textContent = originalLabel;
                addBtn.disabled = false;
              }, 600);
            })
            .catch(function (err) {
              console.error('[mc-cj] erro add:', err);
              if (cjCtaLabel) cjCtaLabel.textContent = originalLabel;
              addBtn.disabled = false;
            });
        });
      }
    }

    /* ============== LIGHTBOX ============== */
    initLightbox();
  }

  function initLightbox() {
    var lightbox = document.querySelector('[data-mc-lightbox]');
    if (!lightbox) return;

    var lbImg     = lightbox.querySelector('[data-mc-lightbox-img]');
    var lbClose   = lightbox.querySelector('[data-mc-lightbox-close]');
    var lbPrev    = lightbox.querySelector('[data-mc-lightbox-prev]');
    var lbNext    = lightbox.querySelector('[data-mc-lightbox-next]');
    var lbCounter = lightbox.querySelector('[data-mc-lightbox-counter]');
    var lbThumbs  = lightbox.querySelectorAll('[data-mc-lightbox-thumb]');
    var galleryItems = document.querySelectorAll('[data-mc-image-index]');

    if (!galleryItems.length) return;

    var images = [];
    galleryItems.forEach(function (item) {
      images.push(item.dataset.mcImageUrl);
    });

    var currentIdx = 0;

    function show(idx) {
      if (idx < 0) idx = images.length - 1;
      if (idx >= images.length) idx = 0;
      currentIdx = idx;

      lbImg.src = images[idx];
      lbImg.alt = 'Imagem ' + (idx + 1);

      if (lbCounter) lbCounter.textContent = (idx + 1) + ' / ' + images.length;

      lbThumbs.forEach(function (t) { t.classList.remove('is-active'); });
      var activeThumb = lightbox.querySelector('[data-mc-lightbox-thumb="' + idx + '"]');
      if (activeThumb) {
        activeThumb.classList.add('is-active');
        activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    function open(idx) {
      show(idx);
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function close() {
      lightbox.hidden = true;
      document.body.style.overflow = '';
    }

    galleryItems.forEach(function (item) {
      item.addEventListener('click', function () {
        var idx = parseInt(item.dataset.mcImageIndex, 10);
        open(idx);
      });
    });

    if (lbClose) lbClose.addEventListener('click', close);
    if (lbPrev)  lbPrev.addEventListener('click', function () { show(currentIdx - 1); });
    if (lbNext)  lbNext.addEventListener('click', function () { show(currentIdx + 1); });

    lbThumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        show(parseInt(t.dataset.mcLightboxThumb, 10));
      });
    });

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape')           close();
      else if (e.key === 'ArrowLeft')   show(currentIdx - 1);
      else if (e.key === 'ArrowRight')  show(currentIdx + 1);
    });

    var touchStartX = 0;
    lightbox.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    lightbox.addEventListener('touchend', function (e) {
      var delta = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) < 50) return;
      if (delta > 0) show(currentIdx - 1);
      else show(currentIdx + 1);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdp);
  } else {
    initPdp();
  }

  document.addEventListener('shopify:section:load', function () { initPdp(); });
})();